import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConsultaPaginada, ConsultaPaginadaResultado } from 'maestro-ng';
import { BaseService } from '../services/base-service.service';
import { AuditoriaConsultaProcesso } from './processo-auditoria-acesso.model';

@Injectable()
export class ProcessoAuditoriaAcessoService extends BaseService<AuditoriaConsultaProcesso, number> {

  constructor(http: HttpClient) {
    super('processoAuditoriaAcesso', http);
  }

  public recuperarPaginado(consulta: ConsultaPaginada): Promise<ConsultaPaginadaResultado<AuditoriaConsultaProcesso>> {
    return this.service.recuperarPaginado(consulta);
  }
}
